<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  reportLink: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['copyLink', 'shareWhatsapp']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Envie esta avaliação do imóvel para o proprietário">
    <p class="text-[13px] leading-relaxed text-lais-text-body">
      Compartilhe os resultados e garanta o melhor preço para o anúncio deste
      imóvel
    </p>
    <label
      for="imovel-report-link"
      class="mt-4 block text-[12px] font-semibold text-lais-text"
    >
      O link abaixo pode ser copiado e enviado
    </label>
    <div class="mt-2 flex min-w-0 items-center gap-2">
      <input
        id="imovel-report-link"
        :value="reportLink"
        readonly
        class="h-10 min-w-0 flex-1 rounded-lais-sm border border-lais-border bg-white px-3 text-[13px] text-lais-text placeholder:text-lais-text-muted focus:border-lais-primary focus:outline-none"
      />
      <button
        type="button"
        class="grid size-10 shrink-0 place-items-center rounded-lais-sm border border-lais-border bg-white text-lais-icon transition-colors hover:border-lais-primary hover:text-lais-primary"
        aria-label="Copiar link da avaliação"
        @click="emit('copyLink')"
      >
        <span class="i-lucide-copy size-4" aria-hidden="true" />
      </button>
    </div>
    <LaisPrimaryButton
      class="mt-4 w-full"
      variant="primary"
      icon="i-lucide-message-circle"
      @click="emit('shareWhatsapp')"
    >
      Compartilhar no WhatsApp
    </LaisPrimaryButton>
  </LaisCard>
</template>
